/* eslint-disable */
import HttpService from '../HttpService';

export default class ProcessControlFileService {
  constructor() {
    this._httpService = new HttpService('/analytics/process_control_file');
  }

  async FindAllByFilters(params) {
    return this._httpService.get('/find_all_by_filters', params);
  }

  async Cancellation(processControlFileId) {
    return await this._httpService.post(`/${processControlFileId}/cancellation`);
  }
}
